var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',[_c('label',[_vm._v(_vm._s(_vm.field.etiqueta))])]),_c('v-btn',{attrs:{"color":"primary","link":"","href":_vm.field.datos.link_url,"target":_vm.field.datos.link_target}},[_vm._v(" "+_vm._s(_vm.field.datos.link_name)+" "),_c('v-icon',{attrs:{"small":"","right":""}},[_vm._v("fas fa-external-link-alt")])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }